module.exports = __webpack_public_path__ + "6b4ec2e0a8bde4c36836467b64e2e674.svg";